
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as aziendaRiB87T4DryrqUBE652ViiRcGJFLO9ceaFfw1pcKYxJgMeta } from "/opt/build/repo/pages/azienda.vue?macro=true";
import { default as partner6QsVZp_pL4UMHCw9zApaKglBWo2t9qsnE5KeD9FjfkUMeta } from "/opt/build/repo/pages/partner.vue?macro=true";
import { default as contattiLkk1bko23CmWlDu8XECUgHS3NHlKXDzryI4CEbL5EV0Meta } from "/opt/build/repo/pages/contatti.vue?macro=true";
import { default as metodo_45adda_45tKdZECPGh9EMeSJABFey8Avaq8Rfb7th5nBG5LA7v0Meta } from "/opt/build/repo/pages/metodo-adda.vue?macro=true";
import { default as indexcH3UCOq2zTN5eiKh6t2Gh42gaACG_J04vvQb2YZncf0Meta } from "/opt/build/repo/pages/ambiti/index.vue?macro=true";
import { default as cookie_45policyMQ1IrFSTamA4lEHpmoUVyvzGXb_YijE_457oG9EsPzDLEMeta } from "/opt/build/repo/pages/cookie-policy.vue?macro=true";
import { default as indexTA86UVweSETJuRJg7Wh_452PMAJAX3sO5n5KcCOmEWBKgMeta } from "/opt/build/repo/pages/servizi/index.vue?macro=true";
import { default as privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as termini_45condizionigm1pp5EzhWqsHuGskfnpCpIWAREnxUF4Eg8r9nTmPa4Meta } from "/opt/build/repo/pages/termini-condizioni.vue?macro=true";
import { default as indexZm2i6EazuEI_8i8JQdP0mGt1Y37AW5R6M5U_45SB6m8YsMeta } from "/opt/build/repo/pages/ambiti/[slug]/index.vue?macro=true";
import { default as indexE4hlDS0714z9EqDADU3c8j4nlgvG9gDVPsxblqA1XkkMeta } from "/opt/build/repo/pages/servizi/[slug]/index.vue?macro=true";
import { default as questionario_45conformitaM35ORUWcbgw936n_Ecb7f_8kEGEVx233zhErVMtYFz0Meta } from "/opt/build/repo/pages/questionario-conformita.vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___it",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "azienda___it",
    path: "/azienda",
    meta: aziendaRiB87T4DryrqUBE652ViiRcGJFLO9ceaFfw1pcKYxJgMeta || {},
    component: () => import("/opt/build/repo/pages/azienda.vue")
  },
  {
    name: "partner___it",
    path: "/partner",
    meta: partner6QsVZp_pL4UMHCw9zApaKglBWo2t9qsnE5KeD9FjfkUMeta || {},
    component: () => import("/opt/build/repo/pages/partner.vue")
  },
  {
    name: "contatti___it",
    path: "/contatti",
    meta: contattiLkk1bko23CmWlDu8XECUgHS3NHlKXDzryI4CEbL5EV0Meta || {},
    component: () => import("/opt/build/repo/pages/contatti.vue")
  },
  {
    name: "metodo-adda___it",
    path: "/metodo-adda",
    meta: metodo_45adda_45tKdZECPGh9EMeSJABFey8Avaq8Rfb7th5nBG5LA7v0Meta || {},
    component: () => import("/opt/build/repo/pages/metodo-adda.vue")
  },
  {
    name: "ambiti___it",
    path: "/ambiti",
    meta: indexcH3UCOq2zTN5eiKh6t2Gh42gaACG_J04vvQb2YZncf0Meta || {},
    component: () => import("/opt/build/repo/pages/ambiti/index.vue")
  },
  {
    name: "cookie-policy___it",
    path: "/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "servizi___it",
    path: "/servizi",
    meta: indexTA86UVweSETJuRJg7Wh_452PMAJAX3sO5n5KcCOmEWBKgMeta || {},
    component: () => import("/opt/build/repo/pages/servizi/index.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/privacy-policy",
    meta: privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "termini-condizioni___it",
    path: "/termini-condizioni",
    meta: termini_45condizionigm1pp5EzhWqsHuGskfnpCpIWAREnxUF4Eg8r9nTmPa4Meta || {},
    component: () => import("/opt/build/repo/pages/termini-condizioni.vue")
  },
  {
    name: "ambiti-slug___it",
    path: "/ambiti/:slug()",
    meta: indexZm2i6EazuEI_8i8JQdP0mGt1Y37AW5R6M5U_45SB6m8YsMeta || {},
    component: () => import("/opt/build/repo/pages/ambiti/[slug]/index.vue")
  },
  {
    name: "servizi-slug___it",
    path: "/servizi/:slug()",
    meta: indexE4hlDS0714z9EqDADU3c8j4nlgvG9gDVPsxblqA1XkkMeta || {},
    component: () => import("/opt/build/repo/pages/servizi/[slug]/index.vue")
  },
  {
    name: "questionario-conformita___it",
    path: "/questionario-conformita",
    meta: questionario_45conformitaM35ORUWcbgw936n_Ecb7f_8kEGEVx233zhErVMtYFz0Meta || {},
    component: () => import("/opt/build/repo/pages/questionario-conformita.vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]